import { CellContext } from "@tanstack/react-table";
import { useMemo, useState, JSX } from "react";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
// import { SimplifiedInputField } from "../../BaseComponents/SimplifiedInputField";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { FieldTypes, FieldStyles } from "../../../Definitions";
import { InputField } from "../../BaseComponents";
import { isObject } from "lodash";


export const DivTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, divStyleOverride, styleOverrideOnValue = true, cell}: CellContext<T, JSX.Element | string | undefined> & EditAbleCell) => {
  const initialValue = useMemo(() => getValue(), [getValue]);
  

  const [value, setValue] = useState(initialValue);

  if (isObject(value)) {
    return (
      <div>
        {value}
      </div>
    )
  }
  const divStyle = divStyleOverride ? divStyleOverride(styleOverrideOnValue ? value : row.original.id) : undefined;
  const onBlur = () => {
    if (value !==initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, value)
    }
  }

  return <StyledDivCell staticColumn={staticColumn} key={cell.id} keyPass={cell.id+"Input"} onBlur={onBlur} onChange={(e: string) => setValue(e)} canEdit={canEdit} cellData={{value, style: divStyle}} />
}

const StyledDivCell = ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn}: StyledTableCellProps & EditAbleCell) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style }} key={keyPass}>
          {String(cellData.value)}
        </div>
      );
    } else {
      return <InputField
        keyPass={keyPass}
        context={cellData.value}
        fieldStyle={FieldStyles.greyTertiary}
        fieldType={FieldTypes.editField}
        textStart={true}
        inTable={true}
        inputType="string"
        onChange={onChange}
        onBlur={onBlur}
        key={keyPass}
        // initialIsFocused={!cellData.value ? true: false}
      />;
    }
  }

  return (
    <div style={cellData.style} key={keyPass}>
      {String(cellData.value)}
    </div>
  )
} 
